import getOr from 'lodash/fp/getOr';
import { GLOBAL_CONSTANTS } from '../../global/constants';

import { calculateTariff, commodity } from "../../utils/api";
import { showLimit } from './searchBar';
import { loadColor } from './tradeAdvisory';
// eslint-disable-next-line no-unused-vars
import { Tariffs } from '../../models/tariffs';
import { genOrderInfoForm } from './orderinfo';
import { TariffField } from '../../models/tariffField';
import { historyPushState, scrollTo, validate } from '../../utils/utils';
import { changeQueryString } from '../../utils/url';
import { validCountries } from '../../global/validCountries';
import { validateOrderInfo } from '../../utils/validate';
import { LocalStorage } from '../../models/LocalStorage';
import { setUpBookDemo } from '../../components/bookNow';
import { setUpChat } from '../../components/chatbox';

const $ = window.jQuery;
let isActiveType = "import";

const ModeTariff = {
  ALL: "all",
  MINIMUM: "minimum_regulation",
  COST_OPTIMIZE: "cost_optimization",
}
const LIMIT_REGULATIONS = 3;

export function setUpTariffEvent() {
  $("body").off("click", ".section-import-tax .destination .detail tbody .item .condition-link");
  $("body").on("click", ".section-import-tax .destination .detail tbody .item .condition-link", function (e) {
    var conditionsText = decodeURIComponent($(this).attr("data-condition"));
    $("#popup-condition .description").html(conditionsText);
    $("#popup-condition").modal("show");
  });

  $("body").on("click", ".box .detail .view-all-button", function (e) {
    $(".tariffSection .item.unselected", $(this).closest(".detail")).addClass("all-selected");
    $(".tariffSection.notdata", $(this).closest(".detail")).css("display", "block");
    $(this).hide();
  });

  $(".section-import-tax.header h2 span").on("click", function () {
    let type = $(this).attr("type");
    $(".section-import-tax.header h2 span").removeClass("active");
    $(this).addClass("active");
    setActiveType(type);
  })

  $("body").off("click", "#btnCalculation");
  $("body").on("click", "#btnCalculation", function () {
    let isForce = false;
    let mode = $(`.filter-tax-type input[name="type_tariff"]:checked`).val();

    if (!mode || mode === ModeTariff.ALL) {
      mode = ModeTariff.MINIMUM;
      $(`.filter-tax-type input[name="type_tariff"][value="${mode}"]`).prop("checked", true).trigger("change");
      isForce = true;
      window.isEdit = true;
    }

    // if (!window.searchData?.export) {
    //   $(".filter-tax-type .required-text").removeClass("hidden");
    // } else {
    //   if (window.orderInfo?.length || isForce) {
    $('#order-info').modal('show');
    $("#order-info .calculate-button").removeClass("hidden");
    $("#order-info .go-button").addClass("hidden");
    if (isForce) {
      $('#order-info .data-form').addClass('loading');
    }
    $(`#order-info .filter-tax-type input[name="type_tariff_modal"][value="${mode}"]`).prop("checked", true);

    let currency = window.searchData?.currency || 'USD';
    $('#order-info .form-group.currency .value').text(currency);
    $('#order-info .input-list .form-group:first-child .input-box .input input').focus();
    $('#order-info .input-list .form-group:first-child .input-box .input select').focus();
    //   } else {
    //     window.isEdit = true;
    //     submitOrderInfo();
    //   }
    // }
  })

  $("body").on("change", "#order-info .input-list .form-group .input-box .input input", function () {
    window.isEdit = true;
  });

  $("body").on("change", "#order-info .input-list .form-group .input-box .input select", function () {
    window.isEdit = true;
  });

  $("body").off("change", `.filter-tax-type.main input[name="type_tariff"]`);
  $("body").on("change", `.filter-tax-type.main input[name="type_tariff"]`, function () {
    let mode = $(this).val();
    let params = window.searchData || {};
    params.mode = mode;
    window.isEdit = true;

    onCalculate(params);
  })

  $("body").off("change", `.filter-tax-type.main input[name="type_tariff_modal"]`);
  $("body").on("change", `.filter-tax-type.main input[name="type_tariff_modal"]`, function () {
    let mode = $(this).val();
    let params = window.searchData || {};
    params.mode = mode;
    window.isEdit = true;
    $('#order-info .data-form').addClass('loading');

    onCalculate(params);

    $(`.filter-tax-type input[name="type_tariff"][value="${mode}"]`).prop("checked", true);
  })

  $(document).off("keypress", "#order-info form");
  $(document).on("keypress", "#order-info form", function (e) {
    if (e.key === "Enter") {
      submitOrderInfo(e);
    }
  });

  $("body").off("click", "#order-info .calculate-button");
  $("body").on("click", "#order-info .calculate-button", submitOrderInfo);

  $("body").on("click", ".filter-tax-type .required-text .link", function (e) {
    let element = $('.export-country select');
    if (element.length && $('.export-country select')[0].selectize) {
      scrollTo($(".section-search"));
      $('.export-country select')[0].selectize.open();
    }
  });

  validCountries.data.forEach(element => {
    const countryOption = new Option(element.name, element.iso2, false, false);
    $(countryOption).attr("data-extra-search", JSON.stringify(element));
    $('.origin-country select').append(countryOption);
  });

  $('.origin-country select').selectize({
    placeholder: "Select country",
    dataAttr: 'data-extra-search',
    searchField: ['value', 'text', 'iso2', 'iso3', 'data-value'],
    onDropdownOpen: function () {
      this.latest = this.getValue() || this.latest;
      this.$input.get(0).selectize.clear(true);
    },
    onBlur: function () {
      if (this.getValue() === '') {
        this.setValue(this.latest);
      }
    },
    onChange: function (value) {
      if (value && value !== this.latest) {
        validate('.origin-country select', undefined, true);
        window.isEdit = true;
      }
    }
  });
  setUpBookDemo();

  $(".book-demo-button .btn").on("click", function () {
    $('#booknow-modal').modal("show");
  })

  setUpChat(true);
}

function submitOrderInfo(e) {
  if (e) {
    e.preventDefault();
  }

  if (!LocalStorage.isLoggedIn() && window.searchData?.mode === ModeTariff.COST_OPTIMIZE) {
    $('#order-info').modal('hide');
    $('#booknow-modal').modal("show");
    return;
  }

  let originOrderInfo = $("#order-info .origin-country select").val();
  let isValid = true;

  if (window.searchData?.mode === ModeTariff.COST_OPTIMIZE && !window.searchData.export && !originOrderInfo) {
    $('#order-info .box.order-info .message').html(`Please select the <span class="link">origin to</span> activate the Most Favored Nation and Free Trade Agreement tariffs`);
    isValid = false;
  }

  if (validateOrderInfo() && isValid) {
    if (window.isEdit) {
      if (!$("#order-info .origin-country").hasClass("hidden") && originOrderInfo && window.searchData) {
        window.searchData.export = originOrderInfo;
        $('.section-search .export-country select')[0].selectize.setValue(originOrderInfo, true);
        let newUrl = changeQueryString("export", originOrderInfo);
        historyPushState(newUrl, true);
      }

      let params = window.searchData || {};
      let currency = window.searchData.currency || 'USD';

      calculateTariff(params, currency, function (data) {
        onSuccess(data, currency, true);
      }, function (error) {
        onError(error);
      });
    }

    $('#order-info').modal('hide');
  }
}

/**
 * 
 * @param {Tariffs} data 
 */
function getOrderInfo(data) {
  let orderInfo = [];

  if (data?.importTariffs?.length) {
    data.importTariffs.forEach(element => {
      let tariffSelected = element.tariffs.filter(i => i.selected);

      tariffSelected.forEach(item => {
        if (Array.isArray(item.inputs) && item.inputs.length) {
          item.inputs.forEach(inputs => {
            if (Array.isArray(inputs) && inputs.length) {
              inputs.forEach(input => {
                input = TariffField.fromApiObject(input);
                if (input.name !== undefined && orderInfo.findIndex(i => i.name === input.name) < 0) {
                  orderInfo.push(input);
                }
              })
            }
          });
        }
      });
    });
  }

  if (data.exportTariffs?.length) {
    data.exportTariffs.forEach(element => {
      let tariffSelected = element.tariffs.filter(i => i.selected);

      tariffSelected.forEach(item => {
        if (Array.isArray(item.inputs) && item.inputs.length) {
          item.inputs.forEach(inputs => {
            if (Array.isArray(inputs) && inputs.length) {
              inputs.forEach(input => {
                input = TariffField.fromApiObject(input);
                if (input.name !== undefined && orderInfo.findIndex(i => i.name === input.name) < 0) {
                  orderInfo.push(input);
                }
              })
            }
          });
        }
      });
    });
  }
  return orderInfo;
}

export const getTariff = (params, apiTime) => {
  resetTariff();
  onCalculate(params);
}

export function onCalculate(query) {
  let params = query || window.searchData || {};
  let currency = params.currency || 'USD';
  commodity(params.destination, params.hs || params.product, params.export, params.mode, currency, function (data) {
    onSuccess(data, currency);
  }, function (error) {
    onError(error);
  });
}
/** @param {Tariffs} data */
function onSuccess(data, currency, isCalculate = false) {
  let isLoggedIn = LocalStorage.isLoggedIn();

  if (data?.importTariffs?.length) {
    let htmlTariff = "";
    // let hasAll = false;
    data.importTariffs.forEach((element, index) => {
      let tariffSelected = element.tariffs.filter(i => i.selected);
      // if (tariffSelected.length !== element.tariffs.length) {
      //   hasAll = true;
      // }
      htmlTariff += tableTariff(element.name, element.genDetailHtml(isCalculate, currency), isCalculate, index === 0 && tariffSelected.length !== element.tariffs.length, tariffSelected.length === 0);
    });
    // if (hasAll) {
    //   htmlTariff = `<div class="view-all-button">View all</div>${htmlTariff}`;
    // }
    $(".section-import-tax.import .destination .detail").html(htmlTariff);
    loadColor();
    $(".section-import-tax.header h2[type='import']").removeClass("hidden");
  } else {
    $(".section-import-tax.import").addClass('no-data');
    $(".section-import-tax.header h2[type='import']").addClass("hidden");
  }
  $(".section-import-tax.import").removeClass('loading').removeClass("contactus");
  $(".section-import-tax.import").toggleClass('contactus', !isLoggedIn);

  if (data.regulations?.length) {
    let htmlTariff = "";
    data.regulations.forEach((element, index) => {
      let isValid = isLoggedIn || (!isLoggedIn && index <= LIMIT_REGULATIONS);
      if (isValid) {
        let tariffSelected = element.docs.filter(i => i.selected);
        htmlTariff += tableRegulation(element.name, element.genHtml(!isLoggedIn ? LIMIT_REGULATIONS : undefined), tariffSelected.length !== element.docs.length, tariffSelected.length === 0);
      }
    });

    $(".section-import-tax.import .destination .detail").append(htmlTariff);
    $(".section-import-tax.import").removeClass('no-data');
  }

  if (data.exportTariffs?.length) {
    let htmlTariff = "";
    data.exportTariffs.forEach(element => {
      let tariffSelected = element.tariffs.filter(i => i.selected);
      htmlTariff += tableTariff(element.name, element.genDetailHtml(isCalculate, currency), isCalculate, tariffSelected.length > element.tariffs.length, tariffSelected.length === 0);
    });
    $(".section-import-tax.export .destination .detail").html(htmlTariff);
    loadColor();
    $(".section-import-tax.header h2[type='export']").removeClass("hidden");
  } else {
    $(".section-import-tax.export").addClass('no-data');
    $(".section-import-tax.header h2[type='export']").addClass("hidden");
  }
  $(".section-import-tax.export").removeClass('loading');

  setActiveType(isActiveType);

  $(".section-import-tax.import .destination .detail tfoot").css("display", "none");
  $(".section-import-tax.export .destination .detail tfoot").css("display", "none");
  $(".section-import-tax.import .destination .detail thead tr.total").css("display", "none");
  $(".section-import-tax.export .destination .detail thead tr.total").css("display", "none");
  $(".filter-tax-type .required-text").addClass("hidden");

  if (!data?.importTariffs?.length && !data.exportTariffs?.length) {
    $(".section-import-tax").css("display", "none");
  } else {
    $(".filter-tax-type.main").removeClass("hidden")
    // if (window.searchData?.export) {
    //   $(".filter-tax-type.main").removeClass("disabled");
    // } else {
    //   $(".filter-tax-type.main").addClass("disabled");
    //   $('.filter-tax-type.main input[name="type_tariff"]').prop('disabled', true);
    //   $(".filter-tax-type .required-text").removeClass("hidden");
    // }
    setTimeout(() => {
      $('.showmore-element').expander({
        slicePoint: 200, // Độ dài tối đa ban đầu
        expandText: 'Show more',
        userCollapseText: 'Show less',
        expandEffect: 'slideDown',
        collapseEffect: 'slideUp'
      });
    }, 0);
  }

  window.orderInfo = getOrderInfo(data);
  genOrderInfoForm(window.orderInfo);
  // if (!window.searchData?.export) {
  //   $("#order-info .origin-country").removeClass("hidden");
  // } else {
  //   $("#order-info .origin-country").addClass("hidden");
  // }
  $("#order-info .origin-country").removeClass("hidden");
  $('#order-info .data-form').removeClass('loading');
  $('#order-info .data-form').attr('mode', window.searchData.mode);
}

function onError(error) {
  window.orderInfo = [];
  $(".section-import-tax").removeClass('loading');
  $(".section-import-tax").css("display", "none");
  $('#order-info .data-form').removeClass('loading');
  const errorCode = getOr('', 'error_code')(error);
  if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
    showLimit();
  }
  console.error(error);
}

function resetTariff() {
  $(".section-import-tax").css("display", "block");
  $(".section-import-tax.import").removeClass('no-data');
  $(".section-import-tax.export").removeClass('no-data');
  $(".section-import-tax .destination .requirement").css("display", "none");
  $(".section-import-tax .destination .box .head .nav-box .item[data-id=customize]").css("display", "none");
  $(".filter-tax-type").addClass("hidden");
  $(".filter-tax-type .required-text").addClass("hidden");
  $(`.filter-tax-type.main input[name="type_tariff"][value="all"]`).prop("checked", true);
  // $('.filter-tax-type.main input[name="type_tariff"]').prop('disabled', false);
}

function setActiveType(type) {
  isActiveType = type;
  $(".section-import-tax.import").css('display', 'none');
  $(".section-import-tax.export").css('display', 'none');

  if (type === "import") {
    $(".section-import-tax.import").css('display', 'block');
  } else {
    $(".section-import-tax.export").css('display', 'block');
  }
}

function tableTariff(name, description, isCalculate, hasAll, isNotSelected) {
  return `
    ${hasAll ? `<div class="view-all-button">View all</div>` : ""}
    <div class="tariffSection${hasAll ? " viewall" : ""}${isNotSelected ? " notdata" : ""}">
      <div class="head">
        <span class="title">${name}</span>
      </div>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            ${isCalculate ? "<th width='20px'>Amount</th>" : ""}
            <th>Rate</th>
            <th>Condition</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          ${description}
        </tbody>
      </table>
    </div>
  `
}

function tableRegulation(name, description, hasAll, isNotSelected) {
  return `
    <div class="tariffSection${hasAll ? " viewall" : ""}${isNotSelected ? " notdata" : ""}">
      <div class="head">
        <span class="title">${name}</span>
      </div>
      <table>
        <thead>
          <tr>
            <th width="40%">Name</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          ${description}
        </tbody>
      </table>
    </div>
  `
}